module.exports = __webpack_public_path__ + "4eb686be75374d452999acf980ee4c5b.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-outlined.ttf
// module id = 354
// module chunks = 0